<template>
  <div id="configContainer">
    <Header v-if="!insideIframe" />

    <div
      style="padding:10px;margin-top:10px;"
      :class="insideIframe ? 'bloc' : 'container bloc'"
    >
      <img
        id="backToAdmin"
        src="data:image/png;base64,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"
        alt="back to admin arrow"
        class="icon"
        v-if="insideIframe"
        @click="goBackToAmdin('new')"
      />
      <div id="mainBody">
        <div class="field">
          <label class="label" id="onlineStateLabel">{{
            $t("board.creation.label.ouverte")
          }}</label>
          <div class="control">
            <label
              class="radio"
              :style="
                editedboard.active == '1'
                  ? 'background-color: green;color:white;'
                  : 'color:black;'
              "
              id="setOnline"
            >
              <input
                id="setOnlineRadio"
                type="radio"
                value="1"
                name="STATE"
                v-model="editedboard.active"
              />
              {{ $t("board.creation.label.oui") }}
            </label>
            <label
              class="radio"
              :style="
                editedboard.active == '0'
                  ? 'background-color: red;color:white;'
                  : 'color:black;'
              "
              id="setOffline"
            >
              <input
                id="setOfflineRadio"
                type="radio"
                value="0"
                name="STATE"
                v-model="editedboard.active"
              />
              {{ $t("board.creation.label.non") }}
            </label>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("board.creation.label.nom") }}</label>
          <div class="control">
            <input
              v-model="editedboard.name"
              name="NAME"
              class="inputPerso"
              type="text"
              :placeholder="$t('board.creation.label.nom')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("board.creation.label.client") }}</label>
          <div class="control">
            <input
              v-model="editedboard.client"
              name="CLIENT"
              class="inputPerso"
              type="text"
              :placeholder="$t('board.creation.label.client')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{
            $t("board.creation.label.evenement")
          }}</label>
          <div class="control">
            <input
              v-model="editedboard.evenement"
              name="EVENEMENT"
              class="inputPerso"
              type="text"
              :placeholder="$t('board.creation.label.evenement')"
            />
          </div>
        </div>

        <!-- Champ Open et close -->
        <div class="field">
          <label class="label">{{ $t("board.openAt") }}</label>
          <div class="control" v-bind:class="{ 'is-loading': isLoading }">
            <b-datepicker
              :max-date="modelCloseAt"
              :locale="this.$store.getters.langue"
              :mobile-modal="false"
              v-model="modelOpenAt"
              :placeholder="$t('board.openAt')"
              expanded
              editable
              :first-day-of-week="0"
            ></b-datepicker>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t("board.closeAt") }}</label>
          <b-datepicker
            :min-date="modelOpenAt > new Date() ? modelOpenAt : todayLastSecond"
            :locale="this.$store.getters.langue"
            :mobile-modal="false"
            v-model="modelCloseAt"
            :placeholder="$t('board.closeAt')"
            expanded
            editable
            :first-day-of-week="0"
          ></b-datepicker>
          <div v-if="modelOpenAt < new Date()" style="margin-top:5px;">
            <b-switch
              style="vertical-align:middle;"
              v-model="closeBoard"
              type="is-warning"
            /><span style="margin-left:-10px;font-size:12px;">{{
              $t("board.close")
            }}</span>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("board.creation.label.type") }}</label>
          <div class="control moderation">
            <label class="radio">
              <input
                type="radio"
                value="moderee"
                name="TYPE"
                v-model="editedboard.mode"
              />
              {{ $t("board.creation.label.moderee") }}
            </label>
            <label class="radio">
              <input
                type="radio"
                value="libre"
                name="TYPE"
                v-model="editedboard.mode"
              />
              {{ $t("board.creation.label.libre") }}
            </label>
          </div>
        </div>

        <div class="field" id="doubleContainer">
          <div id="templateLeft">
            <label class="label">
              {{ $t("board.creation.label.template") }}
              <span v-if="currentTemplate && currentTemplate.owner_id === null">
                <a
                  id="showPictureLink"
                  :href="racine + '' + currentTemplate.url"
                  target="_blank"
                  >{{ $t("board.creation.label.voir") }}</a
                >
              </span>
            </label>
            <div class="control">
              <select v-model="editedboard.template_id">
                <template v-for="item in templates">
                  <option :key="item.id" :value="item.id">{{
                    item.name
                  }}</option>
                </template>
              </select>
            </div>
          </div>
          <div id="colorRight">
            <label class="label">
              {{ $t("board.creation.label.colours") }}
            </label>
            <div id="colorContainer">
              <div
                class="colour"
                :class="
                  editedboard.colours && editedboard.colours.includes(colour)
                    ? 'selected'
                    : 'notSelected'
                "
                v-for="(colour, index) in colours"
                :key="index"
                :style="`background-color:${colour}`"
                @click="colourSelector(colour)"
              ></div>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">
            {{ $t("board.creation.label.upload") }}
            <span v-if="currentTemplate && currentTemplate.owner_id !== null">
              <a :href="racine + '' + currentTemplate.url" target="_blank">{{
                $t("board.creation.label.voir")
              }}</a>
            </span>
          </label>
          <div class="control">
            <b-upload
              class="upload"
              accept="image/png, image/gif, image/jpeg, video/mp4"
              v-model="file"
              input
              v-if="!file"
            >
              <span>
                <img
                  id="addPhoto"
                  src="/static/add_photo.png"
                  alt="picture icon"
                />
                {{ $t("board.creation.button.upload") }}
              </span>
            </b-upload>

            <div v-show="this.oldUrl || (this.Template && this.Template.url)">
              <img
                :src="
                  this.racine + this.oldUrl || this.racine + this.Template.url
                "
                alt="background"
                width="250px"
                ref="imageBackground"
              />
            </div>
            <div v-if="file">
              <b-icon pack="fas" icon="check-square" size="is-small"></b-icon>
              {{ file.name }}
              <span
                @click="deleteBackground(Template.url)"
                class="is-pulled-right"
              >
                <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
              </span>
            </div>
          </div>
          <a id="gabaritPptx" href="../../../static/bigBrain.pptx">{{
            $t("gabarit.pptx")
          }}</a>
        </div>
        <b-message
          type="is-danger"
          v-if="
            editedboard.active == '1' &&
              old_board &&
              old_board.active == '0' &&
              editedboard.posts_count > 0
          "
        >
          {{ $t("brainstormin.previewAndVotes.text") }}
        </b-message>

        <div class="field is-grouped" id="bottomBox">
          <div class="control">
            <button
              id="registerBtn"
              class="button is-primary"
              @click="createBoardButton"
            >
              {{ $t("button.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br /><br />
    <Footer v-if="!insideIframe" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import axios from "axios";

import Header from "../Header";
import Footer from "../Footer";
const { mapState } = createNamespacedHelpers("board");

export default {
  name: "addBoardButton",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      old_board: null,
      colours: [
        "rgb(112,209,248)",
        "rgb(238,110,110)",
        "rgb(96,205,199)",
        "rgb(245,235,153)",
        "rgb(223,173,53)",
        "rgb(96,76,141)",
        "rgb(76,108,160)"
      ],
      file: null,
      Template: null,
      racine: process.env.URL_MEDIA,
      oldUrl: null,
      isLoading: false
    };
  },
  computed: {
    todayLastSecond() {
      let date = new Date();
      date = new Date(date.getTime() - 24 * 60 * 60 * 1000);

      date.setHours(0, 0, 0);
      return date;
    },
    insideIframe() {
      return this.$store.state.auth.insideIframe;
    },

    ...mapState({
      isActive: "isActive",
      editedboard: "editedboard",
      templates: "templates",
      currentTemplate: "currentTemplate",
      boardIsClosed: "boardIsClosed"
    }),
    modelOpenAt: {
      get: function() {
        return this.editedboard.open_at !== null
          ? this.editedboard.open_at
          : null;
      },
      set: function(newValue) {
        this.editedboard.open_at = newValue;
      }
    },
    modelCloseAt: {
      get: function() {
        return this.editedboard.close_at !== null
          ? this.editedboard.close_at
          : null;
      },
      set: function(newValue) {
        newValue.setHours(23, 59, 59);
        this.editedboard.close_at = newValue;
      }
    },
    closeBoard: {
      get: function() {
        if (this.editedboard.closeBoard === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) this.editedboard.close_at = new Date();
        else this.editedboard.close_at = null;
      }
    }
  },
  watch: {
    isActive: {
      handler: function() {
        if (this.currentTemplate !== null) {
          this.oldUrl = this.currentTemplate.url;
        }
      }
    },
    file: {
      handler: function(val) {
        if (this.currentTemplate) {
          this.oldUrl = this.currentTemplate.url;
        }
        if (this.file !== null) {
          this.isLoading = true;
          const formvalues = new FormData();
          formvalues.append("file", this.file);
          formvalues.append("name", this.file.name);
          if (this.editedboard.id !== null) {
            formvalues.append("boardid", this.editedboard.id);
          }
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$store.getters["auth/getToken"];
          axios
            .post(
              process.env.URL_SSO_API +
                "brainstorming/template/" +
                this.$store.state.auth.user.id,
              formvalues
            )
            .then(response => {
              this.Template = response.data;
              this.isLoading = false;
              this.$refs.imageBackground.src = this.racine + this.Template.url;
            })
            .catch(error => {
              // console.log(error)
              this.$buefy.toast.open({
                message:
                  "L'upload de l'image a échoué, pensez à vérifier le poids et la taille de l'image.",
                type: "is-danger",
                position: "is-top"
              });
              this.Template = null;
              this.file = null;
            });
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.$store.dispatch("board/getTemplates", "addBoardButton");
    let message = {
      task: "scrollToTop"
    };
    window.top.postMessage(message, "*");
  },
  mounted() {
    this.old_board = { ...this.editedboard };
  },
  methods: {
    colourSelector(colour) {
      while (typeof this.editedboard.colours === "string") {
        this.editedboard.colours = JSON.parse(this.editedboard.colours);
      }
      // console.log(typeof this.editedboard.colours)

      if (this.editedboard.colours.includes(colour)) {
        if (this.editedboard.colours.length > 1) {
          this.editedboard.colours = this.editedboard.colours.filter(
            selectedColour => colour !== selectedColour
          );
        } else {
          this.$buefy.toast.open({
            message: this.$i18n.t("toast.oneColour"),
            type: "is-danger",
            position: "is-top"
          });
        }
      } else {
        this.editedboard.colours.push(colour);
      }
    },
    deleteBackground(url) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.getters["auth/getToken"];
      axios
        .delete(process.env.URL_SSO_API + "brainstorming/template/" + url)
        .then(response => {
          this.Template = null;
          this.file = null;
          this.$refs.imageBackground.src = this.racine + this.oldUrl;
        });
      // .catch(error => {
      //   this.errors.push(error)
      //   this.$buefy.toast.open({
      //     message:
      //       "L'upload de l'image a échoué, pensez à vérifier le poids et la taille de l'image.",
      //     type: 'is-danger',
      //     position: 'is-top'
      //   })
      // })
    },
    goBackToAmdin: function(str) {
      if (str === "new") {
        this.editedboard.template_id = "null";
        this.Template = null;
        this.file = null;
      }
      this.$router.push({ name: "Admin" });
    },
    createBoardButton: function() {
      if (this.Template !== null) {
        this.editedboard.template_id = this.Template.id;
        this.Template = null;
        this.file = null;
      }

      this.$store.dispatch("board/newBoard", this.editedboard);
      if (this.oldUrl && this.oldUrl !== this.currentTemplate.url) {
        this.deleteBackground(this.oldUrl);
      }
      this.goBackToAmdin();
    },
    addTag(tag) {},
    removeTag(tag) {},
    beforeAdding(tag) {
      if (isEmail(tag)) {
        return true;
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          message: "Adresse mail incorrecte"
        });
        return false;
      }
    }
  }
};

function isEmail(myVar) {
  // La 1ère étape consiste à définir l'expression régulière d'une adresse email
  var regEmail = new RegExp(
    "^[0-9a-z._-]+@{1}[0-9a-z.-]{2,}[.]{1}[a-z]{2,5}$",
    "i"
  );
  return regEmail.test(myVar);
}
</script>

<style scoped>
#backToAdmin {
  cursor: pointer;
}

.bodyContainer {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px 20px 15px;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
}

#onlineStateLabel {
  font-size: 12px;
  font-weight: 600;
  border-bottom: 1px solid black;
  padding-bottom: 6px;
  margin-bottom: 0;
}

#setOffline {
  padding: 10px;
  font-size: 12px;
}

#setOnline {
  padding: 10px;
  font-size: 12px;
}
#setOnline > input:checked + #setOnline {
  background-color: green;
  color: white;
}
#setOffline > input:checked + #setOffline {
  background-color: red;
  color: white;
}

#setOnlineRadio:checked + label {
  background-color: green;
  color: white;
}
#setOfflineRadio:checked + label {
  background-color: red;
  color: white;
}

.inputPerso {
  align-items: center;
  appearance: none;
  background-attachment: scroll;
  background-clip: border-box;
  background-color: #eee;
  background-image: none;
  background-origin: padding-box;
  background-position: 0% 0%;
  background-position-x: 0%;
  background-position-y: 0%;
  background-repeat: repeat;
  background-size: auto;
  border-color: #dbdbdb;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-outset: 0;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-top-style: solid;
  border-top-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: rgb(54, 54, 54);
  display: inline-flex;
  font-size: 12px;
  font-weight: 400;
  height: 27px;
  justify-content: flex-start;
  line-height: 18px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  max-width: 100%;
  padding-bottom: 3.5px;
  padding-left: 6.5px;
  padding-right: 6.5px;
  padding-top: 3.5px;
  position: relative;
  text-align: start;
  text-rendering: optimizelegibility;
  vertical-align: top;
  width: 100%;
  -moz-box-align: center;
  -moz-box-pack: start;
}

.label {
  font-size: 12px;
  font-weight: 600;
}

#configContainer {
  height: 100vh;
  background-color: #e6ecf0;
  overflow: auto;
}

#gabaritPptx {
  font-size: 10px;
  margin-bottom: 10px;
  display: block;
  margin-top: -3px;
  color: #8e8e8e;
}

#colorContainer {
  min-width: 184px;
  display: flex;
  flex-flow: row wrap;
}

.selected {
  border: 2px solid black;
  padding: 0 3px;
  margin: 0 3px;
}
.notSelected {
  margin: 0 3px;
}

.colour {
  width: 20px;
  height: 20px;
}

.moderation {
  width: 100%;
  border: 1px solid #dbdbdb;
  padding: 3px;
  font-size: 12px;
  margin-bottom: 5px;
  background: #eee;
}

#addPhoto {
  height: 18px;
  width: 18px;
  margin-left: 5px;
  margin-right: 10px;
  margin-bottom: -3px;
}

#doubleContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

#templateLeft,
#colorRight {
  min-width: 184px;
  width: 50%;
}
#templateLeft {
  margin-bottom: 7px;
}

#mainBody {
  display: flex;
  flex-flow: column wrap;
}

.brain_blue {
  color: #424a60;
}
.brain_createButton {
  margin: 15px 0;
  display: block;
  cursor: pointer;
}
.brain_createButton img {
  vertical-align: middle;
}
.upload {
  cursor: pointer;
  width: 100%;
  background-color: #eee;
  border: 1px solid #dbdbdb;
  padding: 3px;
  font-size: 12px;
  margin-bottom: 5px;
}

#bottomBox {
  justify-content: flex-end;
}

#registerBtn {
  font-size: 12px;
}

#showPictureLink {
  color: #8e8e8e;
}
</style>



// WEBPACK FOOTER //
// src/components/board/addBoardButton.vue